/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StatusGroupResult {

        public isReadonly: boolean;
        public processStatusGroups: models.ProcessStatusGroup[];
    }
}